// extracted by mini-css-extract-plugin
export default {"empty":"Works_empty__DuP6z","root":"Works_root__5lhR3","CodeMirror":"Works_CodeMirror__I6Cf7","loader":"Works_loader__tJ4g-","works":"Works_works__uLGZ4"};